export { ProductImage } from "./product-image";
